import { List } from "@mui/material";
import React from "react";
import NavSectionItem from "./NavSectionItemList";

export default function NavSection({ sections, setActiveSection }) {
  return (
    <List className="py-0">
      {sections.filter(s => !s.hide_section).map((item, index) => (
        <NavSectionItem
          data={item}
          index={index}
          key={item.value}
          setActiveSection={setActiveSection}
        />
      ))}
    </List>
  );
}
